const google = window.google;

const mapCalculateDistance = ({ latitude, longitude, pointLatitude, pointLongitude }: any) => {
  var p1 = new window.google.maps.LatLng(latitude, longitude);
  var p2 = new window.google.maps.LatLng(pointLatitude, pointLongitude);
  return (window.google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000).toFixed(2);
};

export default mapCalculateDistance;
